module.exports = "<select data-bind=\"value: filter.value,\n\t\t\t\t\toptions: filter.visibleOptions,\n\t\t\t\t\toptionsValue: 'key',\n\t\t\t\t\toptionsText: 'title',\n\t\t\t\t\toptionsCaption: filter.caption\">\n</select>"


//////////////////
// WEBPACK FOOTER
// ./modules/shop/catalog/templates/filters/dropdown-filter.html
// module id = BY5J
// module chunks = 8 9